<template>
    <div class="main">
        <van-search
        v-model="value"
        placeholder="请输入搜索关键词"
        show-action
        shape="round"
        @search="onSearch"
        >
        <div slot="action" @click="onSearch">搜索</div>
        </van-search>
        <div class="selected" v-if="show">
            <ul>
                <li v-for="(item,index) in prolist" :key="index" @click="clickSelect(item)">{{item.fullName}}</li>
            </ul>
        </div>
    </div>
</template>
<script>
    import api from '../../../../service/modules/complaintApis';
    export default {
        data () {
            return {
                value: '',
                show: false,
                prolist: ''
            }
        },
        methods: {
            onSearch () {
                this.getList();
            },
            getList () {
                if (this.value.trim().length === 0) {
                    this.$Toast('搜索条件不能为空');
                    return;
                }
                api.worker.getEnterprise({ 'name': this.value.trim() }).then((res) => {
                    if (res.ret === 0) {
                        this.show = true;
                        this.prolist = res.data.list;
                        console.log(res);
                    }
                })
            },
            clickSelect (value) {
                this.$store.commit('complaint/getCommand', []);
                var arr = [];
                arr.push(value);
                this.$store.commit('complaint/getCommand', arr);
                this.$router.back();
            }

        }
    }
</script>
<style lang="less" scoped>
.main {
    width: 100%;
    .selected {
        width: 100%;
        ul{
            width: 100%;
            li{
                width: 100%;
                list-style: none;
                height: 40px;
                line-height: 40px;
                color: #333;
                font-size: 14px;
                border-bottom: 1px solid #e0e0e0;
                padding-left: 10px;
            }
        }
    }
}
</style>
